
import { commonProd } from "./common.prod";

export const environment = {
  ...commonProd,
  env:'staging',
  trackActions: false,
  terrakio:'https://api.terrak.io',
  terrakioWMS:'wms',
  terrakioWCS:'wcs',
  terrakioKey:'t8jJ8B-2sPnuxGWYerngHaN9BE__Do57oDxMGVqjHRA',
  spatialDownloads: false,
  debug: false,
  debugOverMap:true,
  gaKey:'G-XQ3GHZFLJQ',
  zonalCSVs: 'https://storage.googleapis.com/terrakio_webapps/gwm/'
};

